import React, { useEffect, useState, useContext } from 'react';
import { Card, CardBody } from 'reactstrap';
import axios from 'axios';
import { Table, InputNumber, Input, Form, message, Image, Avatar, Col, Modal } from 'antd';
import { URL } from '../../../config/api';
import { ExclamationCircleOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import {useParams } from "react-router-dom";

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
        >
          <Input style={{width: '60px'}} />
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

const ExampleCard = (props) => {
  const [results, setResults] = useState([]);
  const [form] = Form.useForm();
  const params = useParams();

  useEffect(() => {
    console.log("AAA_PAYMENT", props.payment);
    loadResults();
  }, []);

  const loadResults = async () => {
    const bodyFormData = new FormData();
    bodyFormData.append('LinkId', params.id);
    bodyFormData.append('Payment', params.payment);
    try {
      const res = await axios.post(`${URL}/link/get_stat.php`, bodyFormData);
      if(res.data.Success) {
        const data = res.data.Data;
        data.forEach((item, index) => {
          item.key = index
        });
        setResults(data);
      }else {
        alert(res.data.Message);
      }
    }catch(error) {
      console.log(error);

    }
  }

  var columns = [
    {
      title: 'Date',
      dataIndex: 'Day',
      key: 'Day',
    },
    {
      title: 'Clicks',
      dataIndex: 'Clicks',
      key: 'Clicks',
    },
    {
      title: 'Lifetime Purchases',
      dataIndex: 'Lifetime',
      key: 'Lifetime',
    },
    {
      title: 'Free Trial Sign Ups',
      dataIndex: 'TrialsStarted',
      key: 'TrialsStarted',
    }
  ];

  if(props.payment == 0) {
    columns = [
      {
        title: 'Date',
        dataIndex: 'Day',
        key: 'Day',
      },
      {
        title: 'Clicks',
        dataIndex: 'Clicks',
        key: 'Clicks',
      }
    ];
  }
  return (
    <Col span={24}>
      <Card>
        <CardBody>
          <Form form={form} component={false}>
            <Table 
              components={{
                body: {
                  cell: EditableCell
                }
              }} 
              columns={columns} 
              dataSource={results} />
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
}



export default ExampleCard;
